var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ActivitiesbyType)?_c('AllMyTasksandAppointments',{attrs:{"ActivityType":_vm.ComputedActivityType,"UserRecord":_vm.ActiveUser,"AllEvents":_vm.AppointmentsArray,"ActivitiesArray":_vm.ActivitiesArray,"SystemEntities":_vm.SystemEntities,"UnreadNotifications":_vm.UnreadNotifications},on:{"RemoveActivity":_vm.RemoveActivity}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }